import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const logoFooterFn = /* @__PURE__ */ createRecipe('logo-footer', {}, [])

const logoFooterVariantMap = {}

const logoFooterVariantKeys = Object.keys(logoFooterVariantMap)

export const logoFooter = /* @__PURE__ */ Object.assign(memo(logoFooterFn.recipeFn), {
  __recipe__: true,
  __name__: 'logoFooter',
  __getCompoundVariantCss__: logoFooterFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: logoFooterVariantKeys,
  variantMap: logoFooterVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, logoFooterVariantKeys)
  },
  getVariantProps: logoFooterFn.getVariantProps,
})